import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17.118 8.283a.924.924 0 00-1.332 0l-5.873 5.896-2.3-2.28a.924.924 0 00-1.33 0 .931.931 0 000 1.335l2.965 2.948a.99.99 0 00.665.29.996.996 0 00.666-.29l6.539-6.535a.966.966 0 000-1.364z" fill="currentColor" fillRule="evenodd" /></svg>);